export const ugovor_o_kup_engl = {
    templateId: 213,
    category: 13,
    templateTitle: 'Ugovor o kupoprodaji (na engleskom) - Agreement for sale of goods',
    templateDescription: `<p></p>`,
    description: `

  `,

    sides: [
        {
            signature: 'Seller:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Name of business entity",
              },
              {
                type: "input",
                required: true,
                placeholder: "Street and street number",
              },
              {
                type: "input",
                required: true,
                placeholder: "Place",
              },
              {
                type: "input",
                required: true,
                placeholder: "State",
              },
              {
                type: "input",
                placeholder: "Registered court number",
                inSignature: true,
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Represented by",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Function",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Seller)',
            delimiter: `i`
        },
        {
            signature: 'Buyer:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Name of business entity",
              },
              {
                type: "input",
                required: true,
                placeholder: "Street and street number",
              },
              {
                type: "input",
                required: true,
                placeholder: "Place",
              },
              {
                type: "input",
                placeholder: "Registered court number",
                inSignature: true,
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Represented by",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Function",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Buyer),'
        }
    ],

    headline: 'have concluded following',
    title: 'AGREEMENT FOR SALE OF GOODS',
    noArticleNumbers: true,

    articles: [

     
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/213_ugovor_o_kup_engl.ts